import {loadAppointmentReasons} from "@services/monolith/appointmentReasons";
import {PracticeId} from "src/constants/practiceIds";
import {actions} from "src/store";

import {NextPageContextWithStore} from "../../../store/types";

/**
 * This file is temporary because it should be removed once virtual care pages are merged into one page file.
 */
export default async ({store}: NextPageContextWithStore): Promise<Record<string, never>> => {
  const reasons = await (!store.getState().config.reasons
    ? loadAppointmentReasons(PracticeId.CARBON)
    : Promise.resolve(false as const));

  const payload = {
    pageLoaded: true,
    reasons:
      reasons &&
      reasons.mapPick([
        "id",
        "slug",
        "name",
        "iconName",
        "description",
        "specialtyIds",
        "newPatientDuration",
        "supportsVideoVisit",
        "supportsInstantVisit",
        "practiceApptReasonSpecialties",
      ]),
  }.pickBy();

  // @ts-expect-error TS2345: Argument of type 'Partial<{ pageLoaded: boolean; reasons: false | Pick<PracticeApptReason, keyof PracticeApptReason>[]; }>' is not assignable to parameter of type 'Partial<ConfigState>'.
  store.dispatch(actions.setConfig(payload));

  return {};
};
